import { zodResolver } from "@hookform/resolvers/zod";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { z } from "zod";
import { useTranslation } from "react-i18next";

import Loader from "../../../../../components/Common/Loader";
import { catchAsync, checkResponse } from "../../../../../utilities/utilities";
import {
  AVAILROOM,
  UPDATE_BOOKING,
  VIEW_BOOKING
} from "../../../../../services/ApiCalls";

const EditBooking = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const page = new URLSearchParams(location.search).get("page") || 1;

  const [loader, setLoader] = useState(false);
  const [roomNumbers, setRoomNumbers] = useState(0);
  const [availRooms, setAvailRooms] = useState([]);
  const [selectedRooms, setSelectedRooms] = useState([]);

const schema = z
  .object({
    bookingStatus: z
      .string()
      .min(1, { message: t("bookingUpcoming.edit.errors.bookingStatusRequired") }),

    paymentStatus: z
      .string()
      .min(1, { message: t("bookingUpcoming.edit.errors.paymentStatusRequired") }),

    roomIds: z.array(z.string()).optional(), // make optional first
  })
  .superRefine((data, ctx) => {
    if (
      data.bookingStatus !== "Completed" &&
      (!data.roomIds || data.roomIds.length === 0)
    ) {
      ctx.addIssue({
        path: ["roomIds"],
        message: t("bookingUpcoming.edit.errors.roomRequired"),
        code: z.ZodIssueCode.custom,
      });
    }
  });

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors }
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      roomIds: []
    }
  });

  const toggleRoom = (roomId) => {
    let updated;
    if (selectedRooms.includes(roomId)) {
      updated = selectedRooms.filter(id => id !== roomId);
    } else {
      if (selectedRooms.length >= roomNumbers) return;
      updated = [...selectedRooms, roomId];
    }
    setSelectedRooms(updated);
    setValue("roomIds", updated, { shouldValidate: true });
  };

  const getRoomIds = catchAsync(async (hotelId) => {
    const res = await AVAILROOM({ hotelId });
    checkResponse({ res, setData: setAvailRooms });
  });

  const submitHandler = catchAsync(async (data) => {
    const res = await UPDATE_BOOKING({ ...data, bookingId: id });
    const success = checkResponse({ res, showSuccess: true });
    if (success) navigate(`/upcomming-booking?page=${page}`);
  });

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await VIEW_BOOKING(id);
    const success = checkResponse({ res, setData: () => { }, setLoader });
    if (success && res?.data?.data) {

      const data = res.data.data;
      getRoomIds(data?.bookingDetail?.hotelId?._id);
      setRoomNumbers(data?.bookingDetail?.noOfRoom || 0),
        reset({
          bookingStatus: data?.bookingDetail?.bookingStatus === "Pending" ? "" : data?.bookingDetail?.bookingStatus,
          paymentStatus: data?.bookingDetail?.paymentStatus === "pending" ? "" : data?.bookingDetail?.paymentStatus,
        });
    }
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  return (
    <>
      {loader && <Loader />}
      <section className="addPromo position-relative py-3">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                {/* <Link
                  to={`/upcomming-booking?page=${page}`}
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#E8307A"
                      stroke="#E8307A"
                      strokeWidth="0.2"
                    />
                  </svg>
                </Link> */}
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">{t("bookingUpcoming.edit.title")}</h4>
              </div>
            </Col>

            <Col lg="12">
              <div
                className="formWrpper px-lg-5 p-md-4 p-3 rounded"
                style={{ background: "#EEEEEE" }}
              >                <Form onSubmit={handleSubmit(submitHandler)}>
                  <Row>
                    <Col lg="6" className="my-2">
                      <label>{t("bookingUpcoming.edit.bookingStatus")}</label>
                      <select className="form-control" {...register("bookingStatus")}>
                        <option value="">{t("bookingUpcoming.edit.selectBookingStatus")}</option>
                        <option value="Checked in">{t("bookingUpcoming.edit.checkedIn")}</option>
                        <option value="Cancelled">{t("bookingUpcoming.edit.cancelled")}</option>
                        <option value="Completed">{t("bookingUpcoming.edit.completed")}</option>
                      </select>
                      {errors.bookingStatus && <p className="text-danger">{errors.bookingStatus.message}</p>}
                    </Col>

                    <Col lg="6">
                      <label>{t("bookingUpcoming.edit.paymentStatus")}</label>
                      <select className="form-control" {...register("paymentStatus")}>
                        <option value="">{t("bookingUpcoming.edit.selectPaymentStatus")}</option>
                        <option value="completed">{t("bookingUpcoming.edit.completed")}</option>
                        <option value="refunded">{t("bookingUpcoming.edit.refunded")}</option>
                      </select>
                      {errors.paymentStatus && <p className="text-danger">{errors.paymentStatus.message}</p>}
                    </Col>

                    <Col lg="6" className="mt-3">
                      <label>
                        {t("bookingUpcoming.edit.assignRooms")} ({selectedRooms.length}/{roomNumbers})
                      </label>

                      <div className="border rounded p-2 bg-white" style={{ maxHeight: 220, overflowY: "auto" }}>
                        {availRooms.map(room => {
                          const isSelected = selectedRooms.includes(room._id);
                          const isDisabled = !isSelected && selectedRooms.length >= roomNumbers;

                          return (
                            <div
                              key={room._id}
                              className={`d-flex align-items-center p-2 rounded mb-1
            ${isSelected ? "greyBtn text-white" : "bg-light"}
            ${isDisabled ? "opacity-50" : ""}`}
                              style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
                              onClick={() => !isDisabled && toggleRoom(room._id)}
                            >
                              <input className="me-2" type="checkbox" checked={isSelected} readOnly />
                              {t("bookingUpcoming.edit.floorRoom", {
                                floor: room.floorNumber,
                                room: room.roomNumber
                              })}
                            </div>
                          );
                        })}
                      </div>

                      {errors.roomIds && <p className="text-danger">{errors.roomIds.message}</p>}
                      {selectedRooms.length >= roomNumbers && (
                        <small className="text-warning">
                          {t("bookingUpcoming.edit.roomLimitWarning", { count: roomNumbers })}
                        </small>
                      )}
                    </Col>

                    <Col lg="12" className="mt-4 d-flex justify-content-between">
                      <Link to={`/upcomming-booking?page=${page}`}>
                        <Button variant="secondary">{t("bookingUpcoming.edit.actions.back")}</Button>
                      </Link>
                      <Button type="submit">
                        {id ? t("bookingUpcoming.edit.actions.update") : t("bookingUpcoming.edit.actions.submit")}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default EditBooking;
